import { Inject, Injectable } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { REGEX_CANADA_POSTAL_PATTERN, REGEX_PHONE_PATTERN, REGEX_USA_POSTAL_PATTERN } from "app/app.constants";
import { ShipToCustomer } from "entities/ship-to-customer";
import { Customer } from "entities/customer";
import { BehaviorSubject, Subject} from "rxjs";
import { shipToValidator } from "helpers/ship-to-validator";

export const CheckoutShipToFormConfig = {
  customerName: { maxLength: 35 },
  streetAddress: { maxLength: 60 }
}

export type CheckoutShipToFormGroup = {
  customerName: FormControl<string>;
  streetAddress: FormControl<string>;
  city: FormControl<string>;
  state: FormControl<string>;
  postalCode: FormControl<string>;
  phoneNumber: FormControl<string>;
  mscAccountNumber: FormControl<string>;
};

export type CheckoutShipToForm = {
  customerName: string;
  streetAddress: string;
  city: string;
  state: string;
  postalCode: string;
  phoneNumber: string;
  mscAccountNumber: string;
};

@Injectable({ providedIn: "root" })
export class CheckoutShipToService {
  public editing$: Subject<boolean> = new BehaviorSubject(false);
  private form: FormGroup<CheckoutShipToFormGroup>;

  constructor(
    @Inject(REGEX_PHONE_PATTERN) public regexPhonePattern: string,
    @Inject(REGEX_CANADA_POSTAL_PATTERN) public regexCanadaPostalPattern: RegExp,
    @Inject(REGEX_USA_POSTAL_PATTERN) public regexUSAPostalPattern: RegExp
  ) { }

  public initForm(selected: Customer | ShipToCustomer, deliveryRequiresAddress: boolean, isCanadaUser: boolean): FormGroup<CheckoutShipToFormGroup> {
    const isCash = selected?.addressNumber === '0000200000';
    const addressRequired = deliveryRequiresAddress;
    const isCashCustomerDefaultValues = this.isCashDefault(selected);
    const customerName = isCashCustomerDefaultValues ? "" : selected?.customerName;
    const clearAddressFields = isCash && isCashCustomerDefaultValues;

    this.form = new FormGroup({
      customerName: new FormControl(customerName),
      streetAddress: new FormControl(clearAddressFields ? "" : selected?.streetAddress),
      city: new FormControl(clearAddressFields ? "" : selected?.city),
      state: new FormControl(clearAddressFields ? "" : selected?.state),
      postalCode: new FormControl(clearAddressFields ? "" : selected?.postalCode),
      phoneNumber: new FormControl(selected?.phoneNumber),
      mscAccountNumber: new FormControl(selected?.mscAccountNumber, null)
    }, {
      validators: [
        shipToValidator(
          isCash,
          addressRequired,
          isCanadaUser,
          this.regexCanadaPostalPattern,
          this.regexUSAPostalPattern,
          this.regexPhonePattern)
      ]
    });

    return this.form;
  }

  public createCustomer(): ShipToCustomer {
    return {
      customerName: "",
      customerName2: "",
      addressNumber: "",
      streetAddress: "",
      city: "",
      state: "",
      postalCode: "",
      phoneNumber: "",
      mscAccountNumber: "",
      customerNumber: ""
    } as ShipToCustomer;
  }

  public isCashDefault(selected: Customer | ShipToCustomer): boolean {
    return selected?.addressNumber === '0000200000' && selected.customerName === "RUSH CASH CUSTOMER";
  }

  public setEditing(editing: boolean): void {
    this.editing$.next(editing);
    if (!editing) {
      this.form = null;
    }
  }

  public getForm(): FormGroup<CheckoutShipToFormGroup> {
    return this.form;
  }

}
